export const NOTIFICATION_SHOW = 'NOTIFICATION_SHOW';
export const NOTIFICATION_HIDE = 'NOTIFICATION_HIDE';
export const ERROR_SHOW = 'ERROR_SHOW';
export const ERROR_HIDE = 'ERROR_HIDE';

export const show = (nodeId, text, hash) => ({
    type: NOTIFICATION_SHOW,
    payload: {
        nodeId,
        text,
        hash,
    }
})

export const hide = (nodeId, hash) => ({
    type: NOTIFICATION_HIDE,
    payload: {
        nodeId,
        hash,
    }
})

export const errorShow = (nodeId, text, hash) => ({
    type: NOTIFICATION_SHOW,
    payload: {
        nodeId,
        text,
        hash,
    }
})

export const errorHide = (nodeId, hash) => ({
    type: NOTIFICATION_HIDE,
    payload: {
        nodeId,
        hash,
    }
})